// extracted by mini-css-extract-plugin
module.exports = {"calendar":"DatePicker_calendar__1dqRN","custom_today_day":"DatePicker_custom_today_day__WDcAP"};